import { uniformGridSpec } from '@/utils/gridSpec';

import { LayoutTemplate, TemplateGroup } from '../layoutTemplates.types.ts';
import { PageNames } from '../pageNames.ts';

/** Templates suited to wide (24:10) screens. */
export const wideTemplates: LayoutTemplate[] = [
  {
    id: 'grid-3x2',
    name: 'grid-3x2',
    group: TemplateGroup.Wide,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(3, 2),
  },
  {
    id: 'grid-6x4',
    name: 'grid-6x4',
    group: TemplateGroup.Wide,
    pageName: PageNames.Dashboard,
    spec: uniformGridSpec(6, 4),
  },
];
